import Service from "../../AuthService";
const Dashboard = {

    getSaleGroupBySeller(){
        return Service.get("/dashboard_sale_group_seller");
    },
    getSaleGroupByProduct(){
        return Service.get("/dashboard_sale_group_product");
    },
    getSaleByProduct(data){
        return Service.get(`/dashboard_sale_product?start_date=${data.start_date}&end_date=${data.end_date}&products_type=${data.product_type}&sellers_name=${data.sellers_name}`);
    },
    searchSale(data){
        return Service.post('/dashboard_sale_search',data);
    },
    getSaleGroupBySellerAll(){
        return Service.get("/report_sale_group_seller_all");
    },
    searchSaleGroupBySellerAll(data){
        console.log('api');
        return Service.post('/report_sale_group_seller_all_search',data);
    },
    searchSaleByProduct(data){
        return Service.post('/report_sale_product_search',data);
    },

    //TODO : JANE
    getReportCustomerByProduct(data){
        return Service.get("/dashboard_customer_group_product?"+
            "start_date="+data.start_date +
            "&end_date="+data.end_date +
            "&sale_id="+data.sale_id +
            "&province_id="+data.province_id +
            "&district_id="+data.district_id +
            "&sub_district_id="+data.sub_district_id
        );
    },
    getReportCompareProduct(page,data){
        return Service.get("/dashboard_compare_product?page="+page+
            "&compare_type="+data.compare_type+
            "&start="+data.start+
            "&end="+data.end
        )
    },
    getReportInvoiceSale(page,data){
        return Service.get("/dashboard_invoice_sale?page="+page+
            "&sale_id="+data.sale_id+
            "&start_date="+data.start_date+
            "&end_date="+data.end_date+
            "&province_id="+data.province_id +
            "&district_id="+data.district_id +
            "&sub_district_id="+data.sub_district_id
        )
    },
    //ใบบันทึกข้อความ
    getUpdateLogData(page,data){
        return Service.get(`/update/update_log_data?page=${page}`+
            `&start_date=${data.start_date}` +
            `&end_date=${data.end_date}` +
            `&type=${data.type}`
        );
    },
    saveUpdateLogData(data){
        return Service.post("/update/update_log_data",data);
    },
    printUpdateLogData(data){
        return Service.get(`print_update_data?`+
            `start_date=${data.start_date}` +
            `&end_date=${data.end_date}` +
            `&type=${data.type}`
        );
    },
    getRecordMessage(page){
        return Service.get(`/recode_message?page=${page}`);
    },
    showRecordMessage(id){
        return Service.get(`/recode_message/${id}`);
    },
    createRecordMessage(data){
        return Service.post(`/recode_message`,data);
    },
    updateRecordMessage(id,data){
        return Service.put(`/recode_message/${id}`,data);
    },
    deleteRecordMessage(id){
        return Service.delete(`/recode_message/${id}`);
    },
};
export default Dashboard;
